import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
// import { TEST_USERS } from "../constants/testData";
import { useUser } from "@clerk/clerk-react";
import Intercom from "@intercom/messenger-js-sdk";

type NotificationValues = {
  type: string;
  message: string;
  isVisible: boolean;
};

type AppContextValues = {
  userInfo: any;
  notifications: NotificationValues[];
  showNotifications: (type: string, message: string) => void;
  notificationSliderVisible: boolean;
  setNotificationSliderVisible: Dispatch<SetStateAction<boolean>>;
};

export const AppContext = createContext({} as AppContextValues);

export const useAppContext = () => useContext(AppContext);

export const AppContextProvider = ({ children }: { children: ReactNode }) => {
  // const [userInfo, setUserInfo] = useState({ ...TEST_USERS[0] });
  const { user: userInfo } = useUser();
  const [notifications, setNotifications] = useState([
    { type: "", message: "", isVisible: true },
  ]);
  const [notificationSliderVisible, setNotificationSliderVisible] =
    useState(false);

  const showNotifications = (type: string, message: string) => {
    setNotifications([{ type, message, isVisible: true }]);
    setTimeout(
      () => setNotifications((prev) => ({ ...prev, isVisible: false })),
      3000
    );
  };

  // TODO: Implement when the BE returns a good hash for the user
  // const secretKey = '...p4O0'; // IMPORTANT: your web Identity Verification secret key - keep it safe!
  // const userIdentifier = userInfo.id.toString(); // IMPORTANT: a UUID to identify your user
  // const hash = crypto.createHmac('sha256', secretKey).update(userIdentifier).digest('hex');

  // useEffect(() => {
  //   if (userInfo?.id) {
  //     const email = userInfo.primaryEmailAddress?.toString();
  //     Intercom({
  //       app_id: "fqy3axpk",
  //       user_id: userInfo.id.toString(), // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
  //       name: userInfo.fullName || "", // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
  //       email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
  //       created_at: 1704067200, // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200,
  //       user_hash: hash,
  //     });
  //   }
  // }, [userInfo]);

  return (
    <AppContext.Provider
      value={{
        userInfo,
        notifications,
        showNotifications,
        notificationSliderVisible,
        setNotificationSliderVisible,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
